import script from "./DocumentHome.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentHome.vue?vue&type=script&setup=true&lang=js"

import "./DocumentHome.vue?vue&type=style&index=0&id=4186e4d5&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4186e4d5"]])

export default __exports__